import React, { useEffect, useMemo } from 'react';

// Style
import './Pfizer.scss';
import 'assets/css/rc-tree.min.css';
import 'pages/Thesaurus/Tree.scss';

// Lib
import { listTree } from 'lib/thesaurus';
import { shallowEqual } from 'react-redux';
import { getValueSize } from 'lib/helpers';
import { useRegisterTutorialKey } from 'lib/hooks/useTutorial';
import { useAppDispatch, useAppSelector } from 'lib/hooks/useDispatch';

// components
import List from './components/List';
// import Header from './components/Header';
import HeaderList from './components/HeaderList';
import Breadcrumbs from 'components/Breadcrumbs';
import Accordion from 'components/UiKit/Accordion';
import Description from './components/Description';
import ScrollButton from 'components/ScrollButton';
import PaginationView from 'components/PaginationView';
import CategoriesView from './components/CategoriesView';

// Actions
import * as actionsCreator from './reducer';
import { showMessage } from 'reducers/messages';

// Type
import { TreeNode } from 'pages/Thesaurus/Thesaurus';

// Hooks
import { useWindowSize } from 'lib/hooks';

// Classnames
import clsx from 'clsx';

// Constants
export const optionsSize = [
	{ label: '12', value: 12 },
	{ label: '24', value: 24 },
	{ label: '36', value: 36 },
	{ label: '48', value: 48 },
	{ label: '60', value: 60 },
];

export const Pfizer = () => {
	const dispatch = useAppDispatch();
	const registerTutorialKey = useRegisterTutorialKey();
	const {
		paged,
		currPage,
		goTo,
		pageSize,

		data,
		loading,
		typeViewList,
		toggleFilter,
		categoriesById,
		categoryDescription,
		loadingCategoriesById,

		categoryName,
		selectedKeys,
		expandedKeys,

		allItems,
	} = useAppSelector(
		(store) => {
			return {
				toggleFilter: store.pfizer.toggleFilter,

				data: store.pfizer.categories,
				loading: store.pfizer.loading,

				goTo: store.pfizer.goTo,
				paged: store.pfizer.paged,
				pageSize: store.pfizer.pageSize,
				currPage: store.pfizer.currPage,

				loadingCategoriesById: store.pfizer.loadingCategoriesById,
				categoriesById: store.pfizer.categoriesById,

				typeViewList: store.pfizer.typeViewList,

				allItems: store.pfizer.allItems,

				categoryName: store.pfizer.categoryName,
				categoryDescription: store.pfizer.categoryDescription,

				selectedKeys: store.pfizer.selectedKeys,
				expandedKeys: store.pfizer.expandedKeys,
			};
		},
		shallowEqual
	);
	const total = Math.ceil(categoriesById?.length / (pageSize || 12));

	useEffect(() => {
		registerTutorialKey('categorized-products-category', () => !!data?.length, "normal", "general");
		registerTutorialKey('categorized-products-list', () => !!categoriesById?.length, "normal", "general");
	}, [data, categoriesById]);

	const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e?.key === 'Enter') {
			e.preventDefault();
			dispatch(actionsCreator.changePage((goTo || 1) - 1));
		}
	};

	const submitGoTo = () => {
		dispatch(actionsCreator.changePage((goTo || 1) - 1));
	};

	const onPagePress = (opt: number) => {
		dispatch(actionsCreator.changePage(opt - 1));
	};

	const onNextPressLast = () => {
		dispatch(actionsCreator.changePage(total - 1));
	};

	const onPrevPressLast = () => {
		dispatch(actionsCreator.changePage(0));
	};

	const handlerChangeGoTo = (event: React.ChangeEvent<HTMLInputElement>) => {
		const number = +event?.target?.value > 0 ? +event?.target?.value : 1;

		if (number <= categoriesById?.length) {
			dispatch(actionsCreator.changeGoTo(number));
		} else {
			dispatch(
				showMessage({
					type: 'info',
					text: 'This is the last record'
				})
			);
		}
	};

	const handlerChangeSize = (data: any) => {
		dispatch(actionsCreator.changeSize(data?.value));
	};

	const valueSize = getValueSize({
		opt: pageSize || 12,
		options: optionsSize
	});

	const treeData: TreeNode[] = listTree({
		key: 'key',
		data: data,
		targetBox: [],
		inputValue: '',
		checkedKeys: []
	});

	const newData = useMemo(() => {
		if (paged && categoriesById?.length) {
			const start = (pageSize || 12) * currPage;
			const end = start + (pageSize || 12);
			return categoriesById.slice(start, end);
		}
		return categoriesById;
	}, [categoriesById, paged, currPage, pageSize]);

	const cnWrapper = clsx(
		'pfizer',
		!categoriesById?.length ? 'pfizer--active' : '',
	);

	const cnHeaderList = clsx(
		'pfizer__header-desktop',
		!categoriesById?.length ? 'mt10' : '',
	);

	const { width } = useWindowSize();
	const isDesktop = +width < 1024;

	return (
		<div className={cnWrapper}>
			<ScrollButton />

			{toggleFilter && <div
				className="pfizer__filter-mobile"
			>
				<CategoriesView
					uniqId="categorized-products-tree"
					data={treeData}
					loading={loading}
					expandedKeys={expandedKeys}
					selectedKeys={selectedKeys}
					allItems={allItems}
					className="pfizer__filter-mobile-tree"
				/>
			</div>}

			<div className="wrapper">
				<Breadcrumbs isLast className="mb30" />
				{/*<Header />*/}

				{((total || 0) > 1) && <PaginationView
					className="mb20"

					isShowSelect
					labelForSelect="Products per page:"

					isWhite

					goTo={goTo}
					onKeyPress={onKeyPress}
					handlerSubmitGoTo={submitGoTo}
					handlerChangeGoTo={handlerChangeGoTo}

					number={currPage}
					totalPages={total}
					onPagePress={onPagePress}
					onNextPressLast={onNextPressLast}
					onPrevPressLast={onPrevPressLast}

					valueSize={valueSize}
					optionsSize={optionsSize}
					handlerChangeSize={handlerChangeSize}
				/>}

				{isDesktop && <div className={cnHeaderList}>
					<HeaderList />
				</div>}

				<div className="flex">
					{!isDesktop && <CategoriesView
						data={treeData}
						loading={loading}
						expandedKeys={expandedKeys}
						selectedKeys={selectedKeys}
						allItems={allItems}
						uniqId="categorized-products-tree"
					/>}

					<div className="pfizer__content flex flex-direction-column">
						{categoryName && <Accordion
							isOpen
							title={categoryName}
							className="pfizer__content-accordion mb5"
						>
							<Description description={categoryDescription || ''} />
						</Accordion>}

						<List
							data={newData}
							page={currPage}
							size={pageSize}
							loading={loadingCategoriesById}
							type={isDesktop ? 'cart' : typeViewList}
						/>

						{((total || 0) > 1) && <PaginationView
							className="mt20"

							isShowSelect
							labelForSelect="Per page:"

							isWhite

							goTo={goTo}
							onKeyPress={onKeyPress}
							handlerSubmitGoTo={submitGoTo}
							handlerChangeGoTo={handlerChangeGoTo}

							number={currPage}
							totalPages={total}
							onPagePress={onPagePress}
							onNextPressLast={onNextPressLast}
							onPrevPressLast={onPrevPressLast}

							valueSize={valueSize}
							optionsSize={optionsSize}
							handlerChangeSize={handlerChangeSize}
						/>}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Pfizer;
